import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

export const VideoViewer = observer((props: { documentUuid: string; height?: string }) => {
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [videoReady, setVideoReady] = useState(false);

    useEffect(() => {
        setVideoUrl(null);
        setError(null);
        setVideoReady(false);

        let cancelled = false;

        const fetchVideoUrl = async (): Promise<void> => {
            try {
                const apiUrl = `${kuura.getContextPath()}/api/1/video/${props.documentUuid}`;
                const response = await fetch(apiUrl);

                if (!response.ok) {
                    if (!cancelled) setError('Failed to load video');
                    return;
                }

                const data = await response.json();
                if (!cancelled) setVideoUrl(data.url);
            } catch (err) {
                if (!cancelled) setError('Error loading video');
            }
        };

        fetchVideoUrl();

        return () => {
            cancelled = true;
        };
    }, [props.documentUuid]);

    const height = props.height || '100%';

    if (error) {
        return (
            <div className='flex items-center justify-center w-full bg-black text-white' style={{ height }}>
                {error}
            </div>
        );
    }

    return (
        <div className='flex items-center justify-center w-full bg-black' style={{ height }}>
            {videoUrl && (
                <video
                    key={videoUrl}
                    controls
                    className='w-full h-full object-contain'
                    style={{ display: videoReady ? 'block' : 'none' }}
                    src={videoUrl}
                    onCanPlay={() => setVideoReady(true)}
                >
                    Your browser does not support the video tag.
                </video>
            )}
        </div>
    );
});
